import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { SourceReportsRoute } from '../../routing'

export  class SourceReportsPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <SourceReportsRoute />
        </Fragment>
        )
    }
}
